// Profile.jsx
import React, { useEffect, useState, useRef, useCallback } from "react";
import { supabase } from "../../supabase/supabase";
import { addToCart } from "../../utils/cartUtils";
import { useAuth } from "../../contexts/AuthContext";
import {
  // FaInstagram,
  // FaLinkedin,
  FaCog,
  FaPen,
  FaPlus,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaFacebook,
  FaTwitter,
  FaTiktok,
  FaSnapchat,
  FaPinterest,
  FaGithub,
  FaMedium,
  FaDribbble,
  FaBehance,
  FaSlack,
  FaDiscord,
  FaTelegram,
  FaWhatsapp,
  FaReddit,
  FaTumblr,
  FaStackOverflow,
  FaEnvelope,    // for email
  FaRss ,
  FaEllipsisV,
  FaShareAlt,
  FaDonate,
  FaGlobe,
  FaStore,
  FaShoppingCart,
  FaLock,
  FaArrowLeft,
  FaImage,
  FaVideo,
  FaLink,
  FaVolumeUp,
  FaFont,
  FaTh,
  FaMusic,
  FaPlay,
  FaPause,
  FaBackward,
  FaForward,
  FaMapMarkerAlt,  // for location/google maps
  FaPhone,
  FaHeart,
  FaBookmark,
  FaRetweet,
  FaUser,
  FaUserPlus,
  FaChevronDown,
  FaCheck,
  FaEyeSlash,
  FaExclamation,
  FaStar,
  FaBan,
  FaTrash
  // FaYoutube
} from "react-icons/fa";
import { useNavigate, useParams,Link } from "react-router-dom";
import "./Profile.css";
import lazyGif from "../../assets/gifs/liquid_loading.gif";
import nobannerplaceholder from "../../assets/images/nobannerplaceholder.jpg";
import { useLanguage } from "../../contexts/LanguageContext";
import FloatingSidebarButton from "../../components/FloatingSidebarButton/FloatingSidebarButton";
// Currency flags
import aeflag from "../../assets/images/flags/ae_flag.png";
import frflag from "../../assets/images/flags/fr_flag.png";
import lbflag from "../../assets/images/flags/lb_flag.svg";
import qaflag from "../../assets/images/flags/qa_flag.svg";
import saflag from "../../assets/images/flags/saudi_flag.webp";
import syflag from "../../assets/images/flags/syria_flag.webp";
import usflag from "../../assets/images/flags/us_flag.png";

const PRODUCT_MEDIA_BASE_URL =
  "https://dtskgpqvvxcbtcsmedrq.supabase.co/storage/v1/object/public/product-media";

// Resolve product image URL for product-media bucket (usable across components)
const resolveProductImageUrl = (image, userId) => {
  if (!image) return "/default-product.png";
  if (typeof image === "string" && /^(http|https):\/\//i.test(image)) return image;
  if (typeof image === "string" && image.startsWith("data:")) return image;

  try {
    const filename = typeof image === "string" ? image : String(image);
    return `${PRODUCT_MEDIA_BASE_URL}/${userId}/${filename}`;
  } catch (_) {
    return "/default-product.png";
  }
};

const STORE_CATEGORY_COLORS = [
  "#6366f1",
  "#ef4444",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#06b6d4",
  "#22c55e",
  "#f97316",
];

export default function Profile() {
  const { id } = useParams();
  const isOwn = !id;
  const navigate = useNavigate();
  const { currentUser, signOut } = useAuth();
  const [userData, setUserData] = useState(null);
  const [userPosts, setUserPosts] = useState([]);
  const [reposts, setReposts] = useState([]);
  const [savedPosts, setSavedPosts] = useState([]);
  const [likedPosts, setLikedPosts] = useState([]);
  const [tab, setTab] = useState("posts");
  const [availableTabs, setAvailableTabs] = useState([]);
  const [moreOpen, setMoreOpen] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [isFollowing, setIsFollowing] = useState(false);
  const [isFollowLoading, setIsFollowLoading] = useState(false);
  const [isOrganization, setIsOrganization] = useState(false);
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [selectedStats, setSelectedStats] = useState(["posts", "likes", "donates"]);
  const [showStatsEnabled, setShowStatsEnabled] = useState(true);
  const [lockedCount, setLockedCount] = useState(0);
  const [storeProducts, setStoreProducts] = useState([]);
  const [storeCategories, setStoreCategories] = useState([]);
  const [showStoreSettings, setShowStoreSettings] = useState(false);
  const [showManageCategories, setShowManageCategories] = useState(false);
  const [showCategoryEditor, setShowCategoryEditor] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [categoryColor, setCategoryColor] = useState(STORE_CATEGORY_COLORS[0]);
  const [isSavingCategory, setIsSavingCategory] = useState(false);
  const [isUpdatingStoreSettings, setIsUpdatingStoreSettings] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [subscriptionTab, setSubscriptionTab] = useState("winis"); // "winis" or "currency"
  const [subscriptionAmount, setSubscriptionAmount] = useState("");
  const [subscriptionDuration, setSubscriptionDuration] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [winiToUsdRate, setWiniToUsdRate] = useState(null);
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const [isSavingSubscription, setIsSavingSubscription] = useState(false);
  const [isSubscriptionPanelExpanded, setIsSubscriptionPanelExpanded] = useState(true);
  const [activeSubscribers, setActiveSubscribers] = useState(0);
  const [showStopSubscriptionConfirm, setShowStopSubscriptionConfirm] = useState(false);
  const [showSubscribeConfirm, setShowSubscribeConfirm] = useState(false);
  const { translations: tRaw } = useLanguage();
  const t = { ...tRaw?.profilepage };

  // Currency flag map
  const flagMap = {
    AED: aeflag,
    EUR: frflag,
    LBP: lbflag,
    QAR: qaflag,
    SAR: saflag,
    SYP: syflag,
    USD: usflag,
  };

  // Fetch WiniCoin USD rate (same logic as CurrencyConverter)
  useEffect(() => {
    const fetchWiniRate = async () => {
      try {
        const { data: appSettings, error: settingsError } = await supabase
          .from("app_settings")
          .select("wini_to_usd_rate")
          .limit(1)
          .single();

        if (!settingsError && appSettings) {
          setWiniToUsdRate(appSettings.wini_to_usd_rate || null);
        }
      } catch (err) {
        console.error("Error fetching Wini to USD rate:", err);
      }
    };

    if (winiToUsdRate == null) {
      fetchWiniRate();
    }
  }, [winiToUsdRate]);

  // Listen for subscribe button click from LockedSubscriptionCard
  useEffect(() => {
    const handler = () => setShowSubscribeConfirm(true);
    window.addEventListener("profile-subscribe-click", handler);
    return () => window.removeEventListener("profile-subscribe-click", handler);
  }, []);

  // Fetch currencies and wini rate for subscription modal
  useEffect(() => {
    if (!showSubscriptionModal) return;

    const fetchCurrencyData = async () => {
      try {
        // Fetch WiniCoin rate
        const { data: appSettings, error: settingsError } = await supabase
          .from("app_settings")
          .select("wini_to_usd_rate")
          .limit(1)
          .single();

        if (!settingsError && appSettings) {
          setWiniToUsdRate(appSettings.wini_to_usd_rate || null);
        }

        // Fetch currencies
        const { data: currenciesData, error: currenciesError } = await supabase
          .from("currencies")
          .select("*")
          .order("iso");

        if (!currenciesError && currenciesData) {
          const list = currenciesData
            .filter((c) => c.rate && c.name)
            .map((c) => ({
              code: c.iso,
              name: c.name,
              rate: c.rate,
              flag: flagMap[c.iso] || usflag,
            }))
            .sort((a, b) => a.code.localeCompare(b.code));

          setCurrencies(list);
          if (list.length > 0 && !selectedCurrency) {
            setSelectedCurrency(list.find((c) => c.code === "USD") || list[0]);
          }
        }
      } catch (err) {
        console.error("Error fetching currency data:", err);
      }
    };

    fetchCurrencyData();
  }, [showSubscriptionModal]);

  // User icon SVG (same as FloatingSidebarButton)
  const getUserIconSvg = () => {
    return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmM2Y0ZjYiLz4KPHN2ZyB4PSIxMCIgeT0iMTAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM5Y2EzYWYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KPHBhdGggZD0iTTIwIDIxdi0yYTQgNCAwIDAgMC00LTRIOGE0IDQgMCAwIDAtNCA0djIiLz4KPGNpcmNsZSBjeD0iMTIiIGN5PSI3IiByPSI0Ii8+Cjwvc3ZnPgo8L3N2Zz4K";
  };

  // Resolve avatar_url stored as a filename inside avatars/<user_id>/<filename>
  const resolveAvatarUrl = (filename, userId) => {
    if (!filename) return getUserIconSvg();
    if (typeof filename === "string" && /^(http|https):\/\//i.test(filename)) return filename;
    if (typeof filename === "string" && filename.startsWith("data:")) return filename;
    try {
      const path = `${userId}/${filename}`;
      const { data } = supabase.storage.from("avatars").getPublicUrl(path);
      return data?.publicUrl || getUserIconSvg();
    } catch (_) {
      return getUserIconSvg();
    }
  };

  // Resolve media URL for post-media bucket
  const resolveMediaUrl = (filename, userId) => {
    if (!filename) return null;
    if (typeof filename === "string" && /^(http|https):\/\//i.test(filename)) return filename;
    if (typeof filename === "string" && filename.startsWith("data:")) return filename;
    
    try {
      return `https://dtskgpqvvxcbtcsmedrq.supabase.co/storage/v1/object/public/post-media/${userId}/${filename}`;
    } catch (_) {
      return null;
    }
  };

  // Helper to fetch post author profile
  const fetchPostAuthorProfile = useCallback(async (authorId) => {
    try {
      const { data: authorProfile, error } = await supabase
        .from('profiles')
        .select('display_name, username, avatar_url')
        .eq('user_id', authorId)
        .single();
      
      if (error || !authorProfile) {
        return {
          display_name: `User ${authorId.slice(0, 8)}`,
          username: `user_${authorId.slice(0, 8)}`,
          avatar_url: getUserIconSvg()
        };
      }
      
      return {
        display_name: authorProfile.display_name || authorProfile.username || `user_${authorId.slice(0, 8)}`,
        username: authorProfile.username || `user_${authorId.slice(0, 8)}`,
        avatar_url: resolveAvatarUrl(authorProfile.avatar_url, authorId)
      };
    } catch (err) {
      console.error('[Profile] Error fetching author profile:', err);
      return {
        display_name: `User ${authorId.slice(0, 8)}`,
        username: `user_${authorId.slice(0, 8)}`,
        avatar_url: getUserIconSvg()
      };
    }
  }, []);


  const loadProfile = useCallback(async (uid) => {
    try {
      // Check if current user is viewing their own profile
      const isViewingOwnProfile = currentUser?.id === uid;
      
      // 1) fetch user profile from Supabase
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('*')
        .eq('user_id', uid)
        .single();

      if (profileError || !profile) {
        console.error('Profile not found:', profileError);
        return navigate("/404");
      }

      // Resolve avatar and banner URLs from storage when filenames are stored
      const avatarUrl = resolveAvatarUrl(profile?.avatar_url, uid);
      const bannerUrl = profile?.banner_url ? resolveAvatarUrl(profile.banner_url, uid) : nobannerplaceholder;

      // Selected stats order from profile.stats (prefer customStats for mobile)
      const selected = Array.isArray(profile?.stats?.customStats)
        ? profile.stats.customStats
        : Array.isArray(profile?.stats?.selected)
        ? profile.stats.selected
        : ["posts","likes","donates"];
      setSelectedStats(selected.slice(0,3));

      // Show/hide stats flag (default to true)
      const show = profile?.stats?.showStats ?? profile?.stats?.show_stats;
      setShowStatsEnabled(show === undefined ? true : !!show);

      // Get tab order from profile.stats
      let tabOrder = isViewingOwnProfile 
        ? (profile?.stats?.ownerTabOrder || ["posts", "store", "locked", "awm", "reposts", "saved", "liked"])
        : (profile?.stats?.visitorTabOrder || ["posts", "store", "locked", "awm", "reposts"]);
      
      // Filter out AWM tab if awm_enabled is false
      if (profile?.awm_enabled !== true) {
        tabOrder = tabOrder.filter(tabName => tabName !== "awm");
      }
      
      setAvailableTabs(tabOrder);
      
      // Set initial tab to first available tab
      if (tabOrder.length > 0 && !tabOrder.includes(tab)) {
        setTab(tabOrder[0]);
      }

      // Fetch actual counts from database instead of relying on stats jsonb
      // 1) Count posts for this user
      const { count: postsCount, error: postsCountError } = await supabase
        .from('posts')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', uid)
        .eq('is_archived', false);

      if (postsCountError) {
        console.error('Error counting posts:', postsCountError);
      }

      // 2) Count total likes received by this user's posts
      const { count: likesCount, error: likesCountError } = await supabase
        .from('likes')
        .select('*, posts!inner(*)', { count: 'exact', head: true })
        .eq('posts.user_id', uid);

      if (likesCountError) {
        console.error('Error counting likes:', likesCountError);
      }

      // 3) Count supports/donations received (from transactions where user is receiver)
      // Try multiple approaches to get supports count
      let supportsCount = 0;
      
      // First try: transactions table with receiver_id
      const { count: supportsFromTransactions, error: supportsCountError } = await supabase
        .from('transactions')
        .select('*', { count: 'exact', head: true })
        .eq('receiver_id', uid)
        .eq('flow', 'in')
        .eq('field', 'winicoins');

      if (!supportsCountError && supportsFromTransactions) {
        supportsCount = supportsFromTransactions;
      } else {
        console.log('No supports found in transactions table, trying alternative approach...');
        
        // Alternative: Check if there's a supports field in profiles table
        if (profile.supports) {
          supportsCount = profile.supports;
        }
      }

      if (supportsCountError) {
        console.error('Error counting supports:', supportsCountError);
      }

      // 4) Count saves on this user's posts
      const { count: savesCount, error: savesCountError } = await supabase
        .from('saves')
        .select('*, posts!inner(*)', { count: 'exact', head: true })
        .eq('posts.user_id', uid);
      if (savesCountError) {
        console.error('Error counting saves:', savesCountError);
      }

      // 5) Count locked posts
      const { count: lockedPostsCount, error: lockedError } = await supabase
        .from('posts')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', uid)
        .eq('is_locked', true)
        .eq('is_archived', false);
      if (lockedError) {
        console.error('Error counting locked posts:', lockedError);
      }

      // 6) Count active subscribers for this creator
      const { count: activeSubsCount, error: activeSubsError } = await supabase
        .from('subscriptions')
        .select('*', { count: 'exact', head: true })
        .eq('creator_id', uid)
        .eq('status', 'active');

      if (activeSubsError) {
        console.error('Error counting active subscribers:', activeSubsError);
      } else if (typeof activeSubsCount === 'number') {
        setActiveSubscribers(activeSubsCount);
      }

      // Log the counts for debugging
      console.log(`[Profile] Counts for user ${uid}:`, {
        posts: postsCount,
        likes: likesCount,
        supports: supportsCount
      });

      // Helper to safely extract social link strings from jsonb (supports { value, isActive })
      const normalizeSocialLink = (node) => {
        if (!node) return "";

        let raw;
        if (typeof node === "string") {
          raw = node;
        } else if (typeof node === "object") {
          if (node.isActive === false) return "";
          raw = node.value ?? "";
        } else {
          return "";
        }

        raw = String(raw).trim();
        if (!raw) return "";

        // If it already looks like an absolute URL, use it
        if (/^https?:\/\//i.test(raw)) return raw;

        // If it starts with // or www. or contains a dot/path, treat it as a URL and prepend https://
        if (raw.startsWith("//")) return `https:${raw}`;
        if (raw.startsWith("www.") || raw.includes(".") || raw.includes("/")) {
          return `https://${raw}`;
        }

        // Otherwise return as‑is (consumer can decide how to handle)
        return raw;
      };

      // Transform Supabase profile to match expected format
      const userData = {
        id: profile.user_id,
        // Display name for UI
        username: profile.display_name || profile.username || 'User',
        // Handle/slug used in URLs (always the actual username from Supabase)
        handle: profile.username || '',
        profileImage: avatarUrl,
        profession: profile.profession || '',
        bio: profile.bio || '',
        bannerImage: bannerUrl || '',
        likes: likesCount || 0,
        supports: supportsCount || 0,
        posts: postsCount || 0,
        saves: savesCount || 0,
        followers: profile.follower_count || 0,
        following: profile.following_count || 0,
        isOrganization: profile.is_organization || false,
        subscriptionCost: profile.subscription_cost || null,
        subscriptionDuration: profile.subscription_duration || null,
        storeEnabled: profile.store_enabled === true,
        orderingEnabled: profile.ordering_enabled !== false,
        awmEnabled: profile.awm_enabled || false,
        // Social links from social_links jsonb field (normalize structure)
        instagram: normalizeSocialLink(profile.social_links?.instagram),
        linkedin: normalizeSocialLink(profile.social_links?.linkedin),
        youtube: normalizeSocialLink(profile.social_links?.youtube),
        facebook: normalizeSocialLink(profile.social_links?.facebook),
        twitter: normalizeSocialLink(profile.social_links?.twitter),
        github: normalizeSocialLink(profile.social_links?.github),
        slack: normalizeSocialLink(profile.social_links?.slack),
        reddit: normalizeSocialLink(profile.social_links?.reddit),
        pinterest: normalizeSocialLink(profile.social_links?.pinterest),
        tiktok: normalizeSocialLink(profile.social_links?.tiktok),
        snapchat: normalizeSocialLink(profile.social_links?.snapchat),
        discord: normalizeSocialLink(profile.social_links?.discord),
        telegram: normalizeSocialLink(profile.social_links?.telegram),
        whatsapp: normalizeSocialLink(profile.social_links?.whatsapp),
        website: normalizeSocialLink(profile.social_links?.website),
        location: normalizeSocialLink(profile.social_links?.location)
      };

      // Merge business_info jsonb (expects shape { key: { value, isActive } })
      if (profile.business_info && typeof profile.business_info === 'object') {
        const b = profile.business_info;
        const pick = (key) => {
          const node = b?.[key];
          if (!node || node.isActive === false) return '';
          return typeof node === 'object' && 'value' in node ? (node.value ?? '') : node;
        };
        const bEmail = pick('email');
        const bPhone = pick('phone');
        const bWebsite = pick('website');
        const bWhatsapp = pick('whatsapp');
        const bLocation = pick('location');

        userData.email = userData.email || bEmail;
        userData.phone = userData.phone || bPhone;
        userData.website = userData.website || bWebsite;
        userData.whatsapp = userData.whatsapp || bWhatsapp;
        userData.location = userData.location || bLocation;
      }

      setUserData(userData);
      setIsOrganization(!!userData?.isOrganization);
      setLockedCount(lockedPostsCount || 0);
      
      // 2) fetch this user's own posts from Supabase
      let query = supabase
        .from('posts')
        .select('*')
        .eq('user_id', uid)
        .eq('is_archived', false);
      
      // If viewing someone else's profile, exclude private posts
      if (!isViewingOwnProfile) {
        query = query.eq('is_private', false);
      }
      
      const { data: posts, error: postsError } = await query
        .order('created_at', { ascending: false });

      if (postsError) {
        console.error('Error fetching posts:', postsError);
        setUserPosts([]);
      } else {
        const basePosts = Array.isArray(posts) ? posts : [];
        const visiblePosts = isViewingOwnProfile
          ? basePosts
          : basePosts.filter((post) => !post.is_locked);

        // Transform posts to match expected format
        const transformedPosts = await Promise.all(visiblePosts.map(async (post) => {
          // Transform media_names array to media array with proper URLs
          let media = [];
          if (post.media_names && Array.isArray(post.media_names) && post.media_names.length > 0) {
            media = post.media_names.map((filename, index) => {
              // Determine media type from filename
              const isVideo = filename.includes('.mp4') || filename.includes('.mov') || filename.includes('.avi');
              const isAudio = filename.includes('.wav') || filename.includes('.mp3') || filename.includes('.m4a');
              const isImage = !isVideo && !isAudio;
              
              // Construct the storage URL for post-media bucket
              const mediaUrl = resolveMediaUrl(filename, uid);
              
              return {
                type: isVideo ? 'video' : isAudio ? 'audio' : 'image',
                url: mediaUrl,
                index: index
              };
            });
          }

          return {
            id: post.id,
            caption: post.caption || '',
            media: media,
            compressedMedia: media, // Use same media for compressed
            postedById: post.user_id,
            postedByUsername: userData.username,
            postedByProfileImg: userData.profileImage,
            timestamp: post.created_at,
            isDeleted: false,
            isLocked: post.is_locked || false,
            isPrivate: post.is_private || false,
            likeCount: post.like_count || 0,
            commentCount: post.comment_count || 0,
            repostCount: post.repost_count || 0,
            shareCount: post.share_count || 0,
            tags: post.tags || [],
            region: post.region || '',
            hotScore: post.hot_score || 0,
            trendingScore: post.trending_score || 0,
            // Additional fields for compatibility
            isArchived: post.is_archived || false,
            isRepostsEnabled: post.is_reposts_enabled !== false,
            isCountsVisible: post.is_counts_visible !== false,
            isCommentsEnabled: post.is_comments_enabled !== false,
            aspectRatio: post.aspect_ratio,
            audioFilename: post.audio_filename,
            audioUrl: post.audio_filename ? resolveMediaUrl(post.audio_filename, uid) : null,
            qrCodeUrl: post.qr_code_url,
            privacySettings: post.privacy_settings || {},
            engagementSettings: post.engagement_settings || {}
          };
        }));
        
        setUserPosts(transformedPosts);
      }

      // 3) Fetch store products for this user
      try {
        const { data: productsData, error: productsError } = await supabase
          .from("products")
          .select("*")
          .eq("user_id", uid)
          .eq("is_active", true)
          .order("created_at", { ascending: false });

        if (productsError) {
          console.error("Error fetching store products:", productsError);
          setStoreProducts([]);
        } else {
          setStoreProducts(productsData || []);
        }
      } catch (productsErr) {
        console.error("Error fetching store products:", productsErr);
        setStoreProducts([]);
      }

      // 4) Fetch product categories for this user's store
      try {
        const { data: categoriesData, error: categoriesError } = await supabase
          .from("product_categories")
          .select("*")
          .eq("user_id", uid)
          .eq("is_active", true)
          .order("sort_order", { ascending: true });

        if (categoriesError) {
          console.error("Error fetching product categories:", categoriesError);
          setStoreCategories([]);
        } else {
          setStoreCategories(categoriesData || []);
        }
      } catch (categoriesErr) {
        console.error("Error fetching product categories:", categoriesErr);
        setStoreCategories([]);
      }

      // 5) Fetch reposts
      const { data: repostsData, error: repostsError } = await supabase
        .from('reposts')
        .select('*, posts(*)')
        .eq('user_id', uid)
        .order('created_at', { ascending: false });

      if (repostsError) {
        console.error('Error fetching reposts:', repostsError);
        setReposts([]);
      } else {
        const transformedReposts = await Promise.all((repostsData || []).map(async (repost) => {
          const post = repost.posts;
          if (!post) return null;
          
          // Fetch post author profile
          const authorProfile = await fetchPostAuthorProfile(post.user_id);
          
          let media = [];
          if (post.media_names && Array.isArray(post.media_names) && post.media_names.length > 0) {
            media = post.media_names.map((filename, index) => {
              const isVideo = filename.includes('.mp4') || filename.includes('.mov') || filename.includes('.avi');
              const isAudio = filename.includes('.wav') || filename.includes('.mp3') || filename.includes('.m4a');
              const isImage = !isVideo && !isAudio;
              const mediaUrl = resolveMediaUrl(filename, post.user_id);
              
              return {
                type: isVideo ? 'video' : isAudio ? 'audio' : 'image',
                url: mediaUrl,
                index: index
              };
            });
          }

          return {
            id: post.id,
            caption: post.caption || '',
            media: media,
            compressedMedia: media,
            postedById: post.user_id,
            postedByUsername: authorProfile.display_name || authorProfile.username,
            postedByProfileImg: authorProfile.avatar_url,
            timestamp: post.created_at,
            isDeleted: false,
            isLocked: post.is_locked || false,
            isPrivate: post.is_private || false,
            likeCount: post.like_count || 0,
            commentCount: post.comment_count || 0,
            repostCount: post.repost_count || 0,
            shareCount: post.share_count || 0,
            tags: post.tags || [],
            region: post.region || '',
            hotScore: post.hot_score || 0,
            trendingScore: post.trending_score || 0,
            isArchived: post.is_archived || false,
            isRepostsEnabled: post.is_reposts_enabled !== false,
            isCountsVisible: post.is_counts_visible !== false,
            isCommentsEnabled: post.is_comments_enabled !== false,
            aspectRatio: post.aspect_ratio,
            audioFilename: post.audio_filename,
            audioUrl: post.audio_filename ? resolveMediaUrl(post.audio_filename, post.user_id) : null,
            qrCodeUrl: post.qr_code_url,
            privacySettings: post.privacy_settings || {},
            engagementSettings: post.engagement_settings || {}
          };
        }));
        
        setReposts(transformedReposts.filter(Boolean));
      }

      // 4) Fetch saved posts (only for own profile)
      if (isViewingOwnProfile && currentUser?.id) {
        const { data: savesData, error: savesError } = await supabase
          .from('saves')
          .select('*, posts(*)')
          .eq('user_id', currentUser.id)
          .order('created_at', { ascending: false });

        if (savesError) {
          console.error('Error fetching saved posts:', savesError);
          setSavedPosts([]);
        } else {
          const transformedSaved = await Promise.all((savesData || []).map(async (save) => {
            const post = save.posts;
            if (!post) return null;
            
            // Fetch post author profile
            const authorProfile = await fetchPostAuthorProfile(post.user_id);
            
            let media = [];
            if (post.media_names && Array.isArray(post.media_names) && post.media_names.length > 0) {
              media = post.media_names.map((filename, index) => {
                const isVideo = filename.includes('.mp4') || filename.includes('.mov') || filename.includes('.avi');
                const isAudio = filename.includes('.wav') || filename.includes('.mp3') || filename.includes('.m4a');
                const isImage = !isVideo && !isAudio;
                const mediaUrl = resolveMediaUrl(filename, post.user_id);
                
                return {
                  type: isVideo ? 'video' : isAudio ? 'audio' : 'image',
                  url: mediaUrl,
                  index: index
                };
              });
            }

            return {
              id: post.id,
              caption: post.caption || '',
              media: media,
              compressedMedia: media,
              postedById: post.user_id,
              postedByUsername: authorProfile.display_name || authorProfile.username,
              postedByProfileImg: authorProfile.avatar_url,
              timestamp: post.created_at,
              isDeleted: false,
              isLocked: post.is_locked || false,
              isPrivate: post.is_private || false,
              likeCount: post.like_count || 0,
              commentCount: post.comment_count || 0,
              repostCount: post.repost_count || 0,
              shareCount: post.share_count || 0,
              tags: post.tags || [],
              region: post.region || '',
              hotScore: post.hot_score || 0,
              trendingScore: post.trending_score || 0,
              isArchived: post.is_archived || false,
              isRepostsEnabled: post.is_reposts_enabled !== false,
              isCountsVisible: post.is_counts_visible !== false,
              isCommentsEnabled: post.is_comments_enabled !== false,
              aspectRatio: post.aspect_ratio,
              audioFilename: post.audio_filename,
              audioUrl: post.audio_filename ? resolveMediaUrl(post.audio_filename, post.user_id) : null,
              qrCodeUrl: post.qr_code_url,
              privacySettings: post.privacy_settings || {},
              engagementSettings: post.engagement_settings || {}
            };
          }));
          
          setSavedPosts(transformedSaved.filter(Boolean));
        }

        // 5) Fetch liked posts (only for own profile)
        const { data: likesData, error: likesError } = await supabase
          .from('likes')
          .select('*, posts(*)')
          .eq('user_id', currentUser.id)
          .order('created_at', { ascending: false });

        if (likesError) {
          console.error('Error fetching liked posts:', likesError);
          setLikedPosts([]);
        } else {
          const transformedLiked = await Promise.all((likesData || []).map(async (like) => {
            const post = like.posts;
            if (!post) return null;
            
            // Fetch post author profile
            const authorProfile = await fetchPostAuthorProfile(post.user_id);
            
            let media = [];
            if (post.media_names && Array.isArray(post.media_names) && post.media_names.length > 0) {
              media = post.media_names.map((filename, index) => {
                const isVideo = filename.includes('.mp4') || filename.includes('.mov') || filename.includes('.avi');
                const isAudio = filename.includes('.wav') || filename.includes('.mp3') || filename.includes('.m4a');
                const isImage = !isVideo && !isAudio;
                const mediaUrl = resolveMediaUrl(filename, post.user_id);
                
                return {
                  type: isVideo ? 'video' : isAudio ? 'audio' : 'image',
                  url: mediaUrl,
                  index: index
                };
              });
            }

            return {
              id: post.id,
              caption: post.caption || '',
              media: media,
              compressedMedia: media,
              postedById: post.user_id,
              postedByUsername: authorProfile.display_name || authorProfile.username,
              postedByProfileImg: authorProfile.avatar_url,
              timestamp: post.created_at,
              isDeleted: false,
              isLocked: post.is_locked || false,
              isPrivate: post.is_private || false,
              likeCount: post.like_count || 0,
              commentCount: post.comment_count || 0,
              repostCount: post.repost_count || 0,
              shareCount: post.share_count || 0,
              tags: post.tags || [],
              region: post.region || '',
              hotScore: post.hot_score || 0,
              trendingScore: post.trending_score || 0,
              isArchived: post.is_archived || false,
              isRepostsEnabled: post.is_reposts_enabled !== false,
              isCountsVisible: post.is_counts_visible !== false,
              isCommentsEnabled: post.is_comments_enabled !== false,
              aspectRatio: post.aspect_ratio,
              audioFilename: post.audio_filename,
              audioUrl: post.audio_filename ? resolveMediaUrl(post.audio_filename, post.user_id) : null,
              qrCodeUrl: post.qr_code_url,
              privacySettings: post.privacy_settings || {},
              engagementSettings: post.engagement_settings || {}
            };
          }));
          
          setLikedPosts(transformedLiked.filter(Boolean));
        }
      } else {
        setSavedPosts([]);
        setLikedPosts([]);
      }
      
    } catch (error) {
      console.error('Error loading profile:', error);
      navigate("/404");
    }
  }, [navigate, currentUser?.id, fetchPostAuthorProfile]);

  useEffect(() => {
    (async () => {
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('winicoinUsdExchangeRate')
          .eq('key', 'winicoins')
          .single();
        
        if (error) {
          console.error("couldn't load exchange rate", error);
        } else if (data) {
          setExchangeRate(data.winicoinUsdExchangeRate || 0);
        }
      } catch (err) {
        console.error("couldn't load exchange rate", err);
      }
    })();
  }, []);

  useEffect(() => {
    if (!id) {
      // For own profile, check if user is authenticated
      if (!currentUser) {
        navigate("/auth");
        return;
      }
      loadProfile(currentUser.id);
    } else {
      loadProfile(id);
    }
  }, [id, currentUser, navigate, loadProfile]);

  useEffect(() => {
    if (!id || !currentUser?.id) return;
    
    const checkFollowStatus = async () => {
      try {
        const { data, error } = await supabase
          .from('follows')
          .select('id')
          .eq('follower_id', currentUser.id)
          .eq('following_id', id)
          .single();
        
        setIsFollowing(!!data && !error);
      } catch (error) {
        console.error('Error checking follow status:', error);
        setIsFollowing(false);
      }
    };
    
    checkFollowStatus();
  }, [id, currentUser]);

// Add this follow toggle function
const toggleFollow = async () => {
  if (!currentUser || !id) return;
  setIsFollowLoading(true);
  
  try {
    const currentUserId = currentUser.id;
    const targetUserId = id;
    
    if (isFollowing) {
      // Unfollow
      const { error } = await supabase
        .from('follows')
        .delete()
        .eq('follower_id', currentUserId)
        .eq('following_id', targetUserId);
      
      if (error) throw error;
    } else {
      // Follow
      const { error } = await supabase
        .from('follows')
        .insert({
          follower_id: currentUserId,
          following_id: targetUserId
        });
      
      if (error) throw error;
    }
    
    setIsFollowing(!isFollowing);
  } catch (err) {
    console.error("Failed to toggle follow:", err);
  } finally {
    setIsFollowLoading(false);
  }
};
//share
// Helper to generate short share IDs (same pattern as posts)
const generateShareId = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let id = '';
  for (let i = 0; i < 8; i += 1) {
    const idx = Math.floor(Math.random() * chars.length);
    id += chars[idx];
  }
  return id;
};

// Helper to build profile share URL: /@username/userId/shareId/u
const buildProfileShareUrl = () => {
  if (!userData) return window.location.href;

  const usernameSlug = userData.handle || userData.username || '';
  const uid = id || userData.id || currentUser?.id;
  if (!uid || !usernameSlug) return window.location.href;

  const shareId = generateShareId();

  const base =
    (process.env.REACT_APP_SHARE_BASE_URL &&
      process.env.REACT_APP_SHARE_BASE_URL.replace(/\/$/, '')) ||
    (typeof window !== 'undefined'
      ? window.location.origin.replace(/\/$/, '')
      : '');

  return `${base}/@${encodeURIComponent(usernameSlug)}/${uid}/${shareId}/u`;
};

const handleShareProfile = () => {
  try {
    const shareUrl = buildProfileShareUrl();
    const title = `Check out ${userData.username}'s profile`;
    const text = `View ${userData.username}'s profile on iWinto`;

    if (navigator.share) {
      navigator
        .share({
          title,
          text,
          url: shareUrl,
        })
        .catch(err => {
          console.error('Error sharing:', err);
          // Fallback for when sharing fails
          copyToClipboard(shareUrl);
        });
    } else {
      // Fallback for browsers that don't support Web Share API
      copyToClipboard(shareUrl);
    }
  } catch (err) {
    console.error('Error building share URL:', err);
    copyToClipboard(window.location.href);
  }
};

// Helper function for clipboard fallback
const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    alert('Profile link copied to clipboard!');
  }).catch(err => {
    console.error('Failed to copy:', err);
    // Fallback if clipboard API fails
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    alert('Profile link copied to clipboard!');
  });
};



 

  // Handle click outside to close more dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreOpen && !event.target.closest('.more-wrapper')) {
        setMoreOpen(false);
      }
    };

    if (moreOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [moreOpen]);

  // Handle escape key to close fullscreen
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        if (fullscreenImage) {
          closeFullscreen();
        } else if (moreOpen) {
          setMoreOpen(false);
        }
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [fullscreenImage, moreOpen]);

  // Cleanup body scroll on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Reset category selection when leaving store tab
  useEffect(() => {
    if (tab !== "store") {
      setSelectedCategoryId(null);
    }
  }, [tab]);

  // Handle fullscreen image
  const openFullscreen = (imageSrc) => {
    if (imageSrc) {
      setFullscreenImage(imageSrc);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'unset';
  };

  const toggleMore = () => setMoreOpen(o => !o);

  // Function to determine post type
  const getPostType = (post) => {
    // Check if this is a locked post first
    if (post.isLocked === true) {
      return 'locked';
    }
    
    // Check if post has caption with URL
    const hasUrl = post.caption && /(https?:\/\/[^\s]+|www\.[^\s]+)/i.test(post.caption);
    
    // Check media types
    const rawMedia = Array.isArray(post.media) && post.media.length
      ? post.media
      : Array.isArray(post.compressedMedia)
      ? post.compressedMedia
      : [];
    
    const entries = rawMedia.map(r => (typeof r === "string" ? JSON.parse(r) : r)).filter(Boolean);
    
    // If has media, determine type based on media FIRST
    if (entries.length > 0) {
      const types = entries.map(entry => entry.type).filter(Boolean);
      
      if (types.includes('video')) return 'video';
      if (types.includes('audio')) return 'audio';
      if (types.includes('image')) {
        // If it has images AND URL, it's a link post with thumbnail
        if (hasUrl) return 'link';
        // If it only has images, it's an image post
        return 'image';
      }
    }
    
    // If has URL in caption but no media, it's a link post without thumbnail
    if (hasUrl) {
      return 'link';
    }
    
    // If only caption with no media and no URL, it's text
    if (post.caption && rawMedia.length === 0) {
      return 'text';
    }
    
    return 'other';
  };

  // Get feed based on selected tab
  const getFeedForTab = (selectedTab) => {
    switch (selectedTab) {
      case "posts":
        // For owner, filter out locked posts from the "all posts" tab
        // Locked posts should only appear in the "locked" tab
        return isOwn 
          ? userPosts.filter(post => post.isLocked !== true)
          : userPosts;
      case "locked":
        return userPosts.filter(post => post.isLocked === true);
      case "reposts":
        return reposts;
      case "saved":
        return savedPosts;
      case "liked":
        return likedPosts;
      case "store":
        // Use store products for store tab
        return storeProducts;
      case "awm":
        // AWM posts - for now return empty, can be implemented later
        return [];
      default:
        return userPosts;
    }
  };

  if (!userData) return <div className="loading">Loading…</div>;

  const handleLogout = async () => {
    await signOut();
    navigate("/auth");
  };

  // Calculate winicoins from currency amount
  const calculateWinicoinsFromCurrency = (currencyAmount, currencyRate) => {
    if (!currencyAmount || !currencyRate || !winiToUsdRate) return 0;
    const usd = parseFloat(currencyAmount) / parseFloat(currencyRate);
    return usd / winiToUsdRate;
  };

  // Save subscription settings
  const handleSaveSubscription = async () => {
    if (!subscriptionAmount || !subscriptionDuration) {
      alert("Please fill in both amount and duration");
      return;
    }

    const durationNum = parseInt(subscriptionDuration);
    if (durationNum < 10 || durationNum > 60) {
      alert("Duration must be between 10 and 60 days");
      return;
    }

    setIsSavingSubscription(true);
    try {
      let finalCost;
      
      if (subscriptionTab === "winis") {
        // Direct winicoins input
        finalCost = parseFloat(subscriptionAmount);
      } else {
        // Convert from currency to winicoins
        if (!selectedCurrency) {
          alert("Please select a currency");
          setIsSavingSubscription(false);
          return;
        }
        finalCost = calculateWinicoinsFromCurrency(subscriptionAmount, selectedCurrency.rate);
      }

      if (!finalCost || finalCost <= 0) {
        alert("Invalid amount");
        setIsSavingSubscription(false);
        return;
      }

      // Update profile in database
      const { error } = await supabase
        .from("profiles")
        .update({
          subscription_cost: finalCost,
          subscription_duration: durationNum
        })
        .eq("user_id", currentUser?.id);

      if (error) {
        console.error("Error saving subscription:", error);
        alert("Failed to save subscription settings. Please try again.");
      } else {
        // Update local state
        setUserData(prev => ({
          ...prev,
          subscriptionCost: finalCost,
          subscriptionDuration: durationNum
        }));
        
        // Close modal and reset form
        setShowSubscriptionModal(false);
        setSubscriptionAmount("");
        setSubscriptionDuration("");
        setSubscriptionTab("winis");
        setSelectedCurrency(null);
        
        // Reload profile to refresh the UI
        if (currentUser?.id) {
          loadProfile(currentUser.id);
        }
      }
    } catch (err) {
      console.error("Error saving subscription:", err);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSavingSubscription(false);
    }
  };

  // Stop / delete subscription (reset to NULL)
  const handleStopSubscription = async () => {
    if (!currentUser?.id) return;

    setIsSavingSubscription(true);
    try {
      const { error } = await supabase
        .from("profiles")
        .update({
          subscription_cost: null,
          subscription_duration: null,
        })
        .eq("user_id", currentUser.id);

      if (error) {
        console.error("Error stopping subscription:", error);
        alert("Failed to stop subscription. Please try again.");
        return;
      }

      setUserData((prev) => ({
        ...prev,
        subscriptionCost: null,
        subscriptionDuration: null,
      }));
      setActiveSubscribers(0);
      setIsSubscriptionPanelExpanded(false);
      setShowStopSubscriptionConfirm(false);
    } catch (err) {
      console.error("Error stopping subscription:", err);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSavingSubscription(false);
    }
  };

  const feed = getFeedForTab(tab);
  const isEmpty = feed.length === 0;

  const showOwnerSubscriptionSetupPrompt =
    tab === "locked" &&
    isOwn &&
    (!userData?.subscriptionCost || !userData?.subscriptionDuration);

  const showVisitorSubscriptionCard =
    tab === "locked" &&
    !isOwn &&
    !!userData?.subscriptionCost &&
    !!userData?.subscriptionDuration;

  const showStoreDisabledPrompt =
    tab === "store" &&
    isOwn &&
    userData?.storeEnabled === false;

  // Enable store handler
  const handleEnableStore = async () => {
    if (!currentUser?.id) return;

    try {
      const { error } = await supabase
        .from("profiles")
        .update({
          store_enabled: true,
        })
        .eq("user_id", currentUser.id);

      if (error) {
        console.error("Error enabling store:", error);
        alert("Failed to enable store. Please try again.");
        return;
      }

      // Update local state
      setUserData((prev) => ({
        ...prev,
        storeEnabled: true,
      }));

      // Reload profile to refresh UI
      if (currentUser?.id) {
        loadProfile(currentUser.id);
      }
    } catch (err) {
      console.error("Error enabling store:", err);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="profile-wrapper">
      <FloatingSidebarButton userProfile={userData} />
      <button className="profile-back-btn" onClick={() => navigate(-1)}>
        <FaArrowLeft />
      </button>
      <div className="profile-info">
        <div 
          className="profile-banner"
          style={{ '--banner-url': `url(${userData.bannerImage})` }}
        >
          <img 
            src={userData.bannerImage} 
            alt="Banner" 
            onClick={() => openFullscreen(userData.bannerImage)}
            style={{ cursor: 'pointer' }}
          />
        </div>
        <img
          className="profile-avatar"
          src={userData.profileImage || ""}
          alt="Avatar"
          onClick={() => openFullscreen(userData.profileImage)}
          style={{ cursor: 'pointer' }}
        />
        <h2>{userData.username}</h2>
        {userData.profession && (
          <p className="profile-profession">{userData.profession}</p>
        )}

        {showStatsEnabled && (
        <div className="profile-stats">
          {selectedStats.slice(0,3).map((key) => {
            const labels = {
              posts: t?.posts || "posts",
              likes: t?.likes || "likes",
              donates: t?.donates || "donates",
              followers: "followers",
              following: "following",
              saves: "saves",
              locked: "locked content",
            };
            const values = {
              posts: userData.posts || 0,
              likes: userData.likes || 0,
              donates: Math.floor((userData.supports || 0) * exchangeRate),
              followers: userData.followers || 0,
              following: userData.following || 0,
              saves: userData.saves || 0,
              locked: lockedCount || 0,
            };
            return (
              <span key={key}><strong>{values[key] ?? 0}</strong> {labels[key]}</span>
            );
          })}
        </div>
        )}
        {userData.bio && <p className="profile-bio">{userData.bio}</p>}

        <div className="profile-links">
          <div className="social-links">
            {!!userData.instagram && (
              <a
                href={userData.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
            )}
            {!!userData.linkedin && (
              <a
                href={userData.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            )}
            {!!userData.youtube && (
              <a
                href={userData.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </a>
            )}
            {!!userData.facebook && (
              <a
                href={userData.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
            )}
            {!!userData.twitter && (
              <a
                href={userData.twitter}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
            )}
            {!!userData.github && (
              <a
                href={userData.github}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub />
              </a>
            )}
            {!!userData.slack && (
              <a
                href={userData.slack}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaSlack />
              </a>
            )}
            {!!userData.reddit && (
              <a
                href={userData.reddit}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaReddit />
              </a>
            )}
            {!!userData.pinterest && (
            <a href={userData.pinterest} target="_blank" rel="noopener noreferrer">
              <FaPinterest />
            </a>
          )}
          {!!userData.tiktok && (
            <a href={userData.tiktok} target="_blank" rel="noopener noreferrer">
              <FaTiktok />
            </a>
          )}
          {!!userData.snapchat && (
            <a href={userData.snapchat} target="_blank" rel="noopener noreferrer">
              <FaSnapchat />
            </a>
          )}
          {!!userData.discord && (
            <a href={userData.discord} target="_blank" rel="noopener noreferrer">
              <FaDiscord />
            </a>
          )}
          {!!userData.telegram && (
            <a href={userData.telegram} target="_blank" rel="noopener noreferrer">
              <FaTelegram />
            </a>
          )}
            {!!userData.whatsapp && (
              <a 
                href={`https://wa.me/${userData.whatsapp.replace(/[^\d]/g, '')}`} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaWhatsapp />
              </a>
            )}
          {!!userData.email && (
            <a href={`mailto:${userData.email}`} target="_blank" rel="noopener noreferrer">
              <FaEnvelope />
            </a>
          )}
          {!!userData.phone && (
            <a href={`tel:${userData.phone}`} target="_blank" rel="noopener noreferrer">
              <FaPhone />
            </a>
          )}
           {!!userData.website && (
            <a
              href={
                userData.website.startsWith("http://") || userData.website.startsWith("https://")
                  ? userData.website
                  : `https://${userData.website}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGlobe />
            </a>
          )}
            {!!userData.location && (
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(userData.location)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaMapMarkerAlt />
              </a>
            )}
          </div>
          {!isOwn && (
            <div className="profile-follow-store">
              <button 
                className={`btn-follow ${isFollowing ? "following" : ""}`}
                onClick={toggleFollow}
                disabled={isFollowLoading}
              >
                {isFollowLoading ? (
                  t?.loading || "Loading..."
                ) : isFollowing ? (
                  t?.unfollow || "Unfollow"
                ) : (
                  t?.follow || "Follow"
                )}
              </button>
             {isOrganization ? (
              <Link to={`/${id}/store`} className="btn-store">
    {t?.viewStore || "View Store"}
  </Link>
            ) : (
              <button className="btn-share" onClick={handleShareProfile}>
                {/* <FaShareAlt /> */}
                 {t?.shareProfile || "Share Profile"}
              </button>
            )}
              <div className="more-wrapper">
                <button className="btn-more" onClick={toggleMore}>
                  <FaEllipsisV />
                </button>
                {moreOpen && (
                  <div className="more-dropdown">
                    <button className="more-item" onClick={handleShareProfile}>
                      <span>{t?.shareProfile || "Share Profile"}</span>
                      <FaShareAlt className="menu-icon" />
                    </button>
                    <button className="more-item">
                      <span>{t?.orders || "Orders"}</span>
                      <FaDonate className="menu-icon" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {isOwn && (
          <>
            {/* <div className="profile-globe-icon">
              <FaGlobe />
            </div> */}
            <div className="profile-actions">
               <button onClick={() => navigate("/edit-profile")} className="profile-action-btn">
                 <FaPen /> {t?.edit || "Edit Profile"}
               </button>
               <button 
                 onClick={() => {
                   // If on locked tab with active subscription, enable lock post by default
                   const shouldLockPost = tab === "locked" && 
                     userData?.subscriptionCost && 
                     userData?.subscriptionDuration;
                   navigate(shouldLockPost ? "/create?lockPost=true" : "/create");
                 }} 
                 className="profile-action-btn"
               >
                 <FaPlus /> {t?.newPost || "New Post"}
               </button>
               <button onClick={() => navigate("/settings")} className="profile-action-icon">
                 <FaCog />
               </button>
               <button 
                 onClick={() => setTab("store")} 
                 className="profile-action-icon"
                 title={t?.store || "Store"}
               >
                  <FaStore />
              </button>
            </div>
          </>
        )}

        {/* Icon-based Tabs */}
        <div className="profile-icon-tabs">
          {availableTabs.map((tabName) => {
            const getTabIcon = () => {
              switch (tabName) {
                case "posts":
                  return <FaTh />;
                case "store":
                  return <FaStore />;
                case "locked":
                  return <FaLock />;
                case "awm":
                  return (
                    <span className="awm-icon-wrapper">
                      <FaUser />
                      <FaUser />
                      <FaPlus style={{ marginLeft: '2px', fontSize: '0.8em' }} />
                    </span>
                  );
                case "reposts":
                  return <FaRetweet />;
                case "saved":
                  return <FaBookmark />;
                case "liked":
                  return <FaHeart />;
                default:
                  return <FaTh />;
              }
            };

            const getTabLabel = () => {
              switch (tabName) {
                case "posts":
                  return t?.posts || "Posts";
                case "store":
                  return t?.store || "Store";
                case "locked":
                  return t?.filters?.locked || "Locked";
                case "awm":
                  return "AWM";
                case "reposts":
                  return t?.reposts || "Reposts";
                case "saved":
                  return t?.saved || "Saved";
                case "liked":
                  return t?.liked || "Liked";
                default:
                  return tabName;
              }
            };

            return (
              <button
                key={tabName}
                className={`profile-icon-tab ${tab === tabName ? "active" : ""}`}
                onClick={() => setTab(tabName)}
                title={getTabLabel()}
              >
                {getTabIcon()}
              </button>
            );
          })}
        </div>

        {/* Subscription Active Panel (only for own profile on locked tab when subscription exists) */}
        {tab === "locked" && isOwn && userData.subscriptionCost && userData.subscriptionDuration && (
          <div className={`subscription-panel ${isSubscriptionPanelExpanded ? "expanded" : ""}`}>
            <button
              className="subscription-panel-header"
              onClick={() => setIsSubscriptionPanelExpanded((prev) => !prev)}
            >
              <div className="subscription-panel-title-row">
                <FaLock className="subscription-panel-icon" />
                <span className="subscription-panel-title">Subscription Active</span>
              </div>
              <FaChevronDown
                className={`subscription-panel-chevron ${isSubscriptionPanelExpanded ? "open" : ""}`}
              />
            </button>

            {isSubscriptionPanelExpanded && (
              <div className="subscription-panel-body">
                <div className="subscription-panel-row">
                  <span className="subscription-panel-label">Cost:</span>
                  <span className="subscription-panel-value">
                    {Number(userData.subscriptionCost).toFixed(2)} Wini
                    {exchangeRate
                      ? ` ≈ $${(Number(userData.subscriptionCost) * exchangeRate).toFixed(2)}`
                      : ""}
                  </span>
                </div>
                <div className="subscription-panel-row">
                  <span className="subscription-panel-label">Duration:</span>
                  <span className="subscription-panel-value">
                    {userData.subscriptionDuration} days
                  </span>
                </div>
                <div className="subscription-panel-row">
                  <span className="subscription-panel-label">Active Subscribers</span>
                  <span className="subscription-panel-value subscription-panel-subscribers">
                    {activeSubscribers}
                  </span>
                </div>
                <div className="subscription-panel-actions">
                  <button
                    className="subscription-panel-btn edit"
                    onClick={() => {
                      setSubscriptionTab("winis");
                      setSubscriptionAmount(
                        userData.subscriptionCost ? String(userData.subscriptionCost) : ""
                      );
                      setSubscriptionDuration(
                        userData.subscriptionDuration ? String(userData.subscriptionDuration) : ""
                      );
                      setShowSubscriptionModal(true);
                    }}
                  >
                    Edit Subscription
                  </button>
                  <button
                    className="subscription-panel-btn stop"
                    onClick={() => setShowStopSubscriptionConfirm(true)}
                    disabled={isSavingSubscription}
                  >
                    Stop Subscription
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Store controls row (only on own store tab when enabled) */}
        {tab === "store" && isOwn && userData.storeEnabled && (
          <div className="store-controls-row">
            <button
              className="store-pill-btn"
              onClick={() => setShowStoreSettings(true)}
            >
              <FaStore className="store-pill-icon" />
              <span>Controls</span>
            </button>
            <button
              className="store-pill-btn"
              onClick={() => {
                setEditingCategory(null);
                setCategoryName("");
                setCategoryDescription("");
                setCategoryColor(STORE_CATEGORY_COLORS[0]);
                setShowCategoryEditor(true);
              }}
            >
              <FaPlus className="store-pill-icon" />
              <span>Add Category</span>
            </button>
            {storeCategories.map((cat) => (
              <button
                key={cat.id}
                className={`store-category-chip ${selectedCategoryId === cat.id ? "active" : ""}`}
                style={{
                  borderColor: cat.color || "#ef4444",
                  color: selectedCategoryId === cat.id ? "#fff" : (cat.color || "#ef4444"),
                  backgroundColor: selectedCategoryId === cat.id ? (cat.color || "#ef4444") : "transparent",
                }}
                onClick={() => {
                  // Toggle category selection - clicking same category deselects
                  setSelectedCategoryId(selectedCategoryId === cat.id ? null : cat.id);
                }}
              >
                {cat.name}
              </button>
            ))}
          </div>
        )}

        <div
          className={`profile-feed ${
            tab === "locked" && isEmpty && (showOwnerSubscriptionSetupPrompt || showVisitorSubscriptionCard)
              ? "subscription-mode"
              : tab === "store" && showStoreDisabledPrompt
              ? "store-mode"
              : ""
          }`}
        >
          {showStoreDisabledPrompt ? (
            <div className="store-prompt">
              <div className="store-prompt-icon-wrapper">
                <div className="store-prompt-icon">
                  <FaStore />
                </div>
                <FaBan className="store-prompt-slash" />
              </div>
              <h3 className="store-prompt-title">Store is disabled</h3>
              <p className="store-prompt-subtitle">
                Enable your Store so that customers can see your products
              </p>
              <button 
                className="store-prompt-button"
                onClick={handleEnableStore}
              >
                Enable store
              </button>
            </div>
          ) : showOwnerSubscriptionSetupPrompt ? (
            <div className="subscription-prompt">
              <div className="subscription-prompt-icon">
                <FaLock />
              </div>
              <h3 className="subscription-prompt-title">Start Your Subscription</h3>
              <p className="subscription-prompt-subtitle">
                Make money by selling exclusive content to your followers
              </p>
              <button 
                className="subscription-prompt-button"
                onClick={() => setShowSubscriptionModal(true)}
              >
                Get started
              </button>
            </div>
          ) : showVisitorSubscriptionCard ? (
            <LockedSubscriptionCard
              user={userData}
              winiToUsdRate={winiToUsdRate}
            />
          ) : tab === "store" && userData?.storeEnabled === true ? (
            <>
              {/* Filter products by selected category (only for own profile) */}
              {(() => {
                const filteredProducts = isOwn && selectedCategoryId
                  ? storeProducts.filter((p) => p.category_id === selectedCategoryId)
                  : storeProducts;

                // Show add-product-card only for own profile if no category selected or no products in selected category
                const shouldShowAddCard = isOwn && (!selectedCategoryId || filteredProducts.length === 0);

                return (
                  <div className="store-products-grid">
                    {shouldShowAddCard && (
                      <div className="add-product-card" onClick={() => navigate("/add-product")}>
                        <FaPlus className="add-product-card-icon" />
                        <span className="add-product-card-text">Add Product</span>
                      </div>
                    )}
                    {filteredProducts.map((product) => (
                      <StoreProductCard
                        key={product.id}
                        product={product}
                        winiToUsdRate={winiToUsdRate}
                      />
                    ))}
                  </div>
                );
              })()}
              {storeProducts.length === 0 && (
                <div className="profile-empty-state">
                  <img src={lazyGif} alt="No content" />
                  <p>{t?.noProducts || "No Products Yet"}</p>
                </div>
              )}
            </>
          ) : isEmpty ? (
            <div className="profile-empty-state">
              <img src={lazyGif} alt="No content" />
              <p>
                {tab === "locked" 
                  ? (t?.noLockedPosts || "No Locked Posts Yet")
                  : tab === "reposts"
                  ? (t?.noReposts || "No Reposts Yet")
                  : tab === "saved"
                  ? (t?.noSavedPosts || "No Saved Posts Yet")
                  : tab === "liked"
                  ? (t?.noLikedPosts || "No Liked Posts Yet")
                  : (t?.noPosts || "No Posts Yet")
                }
              </p>
            </div>
          ) : (
            feed.map(post => {
              // For reposts, saved, and liked tabs, use the post author's ID
              // For posts and locked tabs, use the profile owner's ID
              const postAuthorId = (tab === "reposts" || tab === "saved" || tab === "liked")
                ? (post.postedById || post.user_id || post.postedByID || post.userId)
                : (id || currentUser?.id);
              
              // When navigating to another user's profile (reposts/saved/liked), use "posts" tab
              // When navigating to own profile posts, use current tab
              const targetTab = (tab === "reposts" || tab === "saved" || tab === "liked")
                ? "posts"
                : tab;
              
              return (
                <SlimPost 
                  key={post.id} 
                  post={post} 
                  userId={postAuthorId}
                  tab={targetTab}
                  isOwn={isOwn}
                />
              );
            })
          )}
        </div>
      </div>

      {/* Fullscreen Image Modal */}
      {fullscreenImage && (
        <div className="fullscreen-modal" onClick={closeFullscreen}>
          <div className="fullscreen-content">
            <button className="fullscreen-close" onClick={closeFullscreen}>
              ×
            </button>
            <div className="fullscreen-frame" style={{ '--media-url': `url(${fullscreenImage})` }}>
              <img 
                src={fullscreenImage} 
                alt="Fullscreen" 
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        </div>
      )}

      {/* Subscription Setup Modal */}
      {showSubscriptionModal && (
        <SubscriptionSetupModal
          subscriptionTab={subscriptionTab}
          setSubscriptionTab={setSubscriptionTab}
          subscriptionAmount={subscriptionAmount}
          setSubscriptionAmount={setSubscriptionAmount}
          subscriptionDuration={subscriptionDuration}
          setSubscriptionDuration={setSubscriptionDuration}
          selectedCurrency={selectedCurrency}
          setSelectedCurrency={setSelectedCurrency}
          currencies={currencies}
          showCurrencyDropdown={showCurrencyDropdown}
          setShowCurrencyDropdown={setShowCurrencyDropdown}
          flagMap={flagMap}
          winiToUsdRate={winiToUsdRate}
          calculateWinicoinsFromCurrency={calculateWinicoinsFromCurrency}
          isSaving={isSavingSubscription}
          onClose={() => {
            setShowSubscriptionModal(false);
            setSubscriptionAmount("");
            setSubscriptionDuration("");
            setSubscriptionTab("winis");
            setSelectedCurrency(null);
            setShowCurrencyDropdown(false);
          }}
          onSave={handleSaveSubscription}
        />
      )}

      {/* Stop Subscription Confirmation Dialog */}
      {showStopSubscriptionConfirm && (
        <div
          className="subscription-stop-overlay"
          onClick={() => setShowStopSubscriptionConfirm(false)}
        >
          <div
            className="subscription-stop-confirmation-dialog"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="subscription-stop-title">Stop Subscription?</h3>
            <p className="subscription-stop-text">
              Are you sure you want to stop your subscription? Your followers will no longer be
              able to subscribe and existing subscribers will not be renewed.
            </p>
            <div className="subscription-stop-actions">
              <button
                className="subscription-modal-button subscription-modal-button-cancel"
                onClick={() => setShowStopSubscriptionConfirm(false)}
                disabled={isSavingSubscription}
              >
                Cancel
              </button>
              <button
                className="subscription-modal-button subscription-modal-button-save subscription-stop-danger"
                onClick={handleStopSubscription}
                disabled={isSavingSubscription}
              >
                {isSavingSubscription ? "Stopping..." : "Stop Subscription"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Subscribe confirmation dialog (visitor subscribes to creator) */}
      {showSubscribeConfirm && !isOwn && userData.subscriptionCost && userData.subscriptionDuration && (
        <div
          className="subscription-buy-overlay"
          onClick={() => setShowSubscribeConfirm(false)}
        >
          <div
            className="subscription-buy-dialog"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="subscription-buy-icon-wrapper">
              <FaLock className="subscription-buy-icon" />
            </div>
            <h3 className="subscription-buy-title">Subscribe</h3>
            <p className="subscription-buy-text">
              Subscribe to {userData.username} for{" "}
              {Number(userData.subscriptionCost).toFixed(2)} Wini for{" "}
              {userData.subscriptionDuration} days.
            </p>
            <div className="subscription-buy-actions">
              <button
                className="subscription-modal-button subscription-modal-button-cancel"
                onClick={() => setShowSubscribeConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="subscription-modal-button subscription-buy-primary"
                onClick={() => {
                  // TODO: Implement subscription purchase flow
                  setShowSubscribeConfirm(false);
                }}
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Store Settings overlay */}
      {showStoreSettings && isOwn && (
        <div
          className="store-settings-overlay"
          onClick={() => setShowStoreSettings(false)}
        >
          <div
            className="store-settings-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="store-settings-header">
              <h3 className="store-settings-title">Store Settings</h3>
              <button
                className="store-settings-close"
                onClick={() => setShowStoreSettings(false)}
              >
                ×
              </button>
            </div>

            <button
              className="store-settings-row"
              onClick={async () => {
                if (!currentUser?.id) return;
                const isCurrentlyDisabled = !userData.storeEnabled;
                const newStoreEnabled = isCurrentlyDisabled;

                setIsUpdatingStoreSettings(true);
                try {
                  const { error } = await supabase
                    .from("profiles")
                    .update({ store_enabled: newStoreEnabled })
                    .eq("user_id", currentUser.id);

                  if (error) {
                    console.error("Error updating store_enabled:", error);
                    alert("Failed to update store status.");
                  } else {
                    setUserData((prev) => ({
                      ...prev,
                      storeEnabled: newStoreEnabled,
                    }));
                  }
                } catch (err) {
                  console.error("Error updating store_enabled:", err);
                  alert("Failed to update store status.");
                } finally {
                  setIsUpdatingStoreSettings(false);
                }
              }}
              disabled={isUpdatingStoreSettings}
            >
              <div className="store-settings-row-left">
                <FaStore className="store-settings-icon" />
                <span className="store-settings-label">Disable Store</span>
              </div>
              <div
                className={`store-toggle ${!userData.storeEnabled ? "on" : ""}`}
              >
                <div className="store-toggle-thumb" />
              </div>
            </button>

            <button
              className="store-settings-row"
              onClick={async () => {
                if (!currentUser?.id) return;
                const isCurrentlyDisabled = !userData.orderingEnabled;
                const newOrderingEnabled = isCurrentlyDisabled;

                setIsUpdatingStoreSettings(true);
                try {
                  const { error } = await supabase
                    .from("profiles")
                    .update({ ordering_enabled: newOrderingEnabled })
                    .eq("user_id", currentUser.id);

                  if (error) {
                    console.error("Error updating ordering_enabled:", error);
                    alert("Failed to update ordering status.");
                  } else {
                    setUserData((prev) => ({
                      ...prev,
                      orderingEnabled: newOrderingEnabled,
                    }));
                  }
                } catch (err) {
                  console.error("Error updating ordering_enabled:", err);
                  alert("Failed to update ordering status.");
                } finally {
                  setIsUpdatingStoreSettings(false);
                }
              }}
              disabled={isUpdatingStoreSettings}
            >
              <div className="store-settings-row-left">
                <FaShoppingCart className="store-settings-icon" />
                <span className="store-settings-label">Disable Ordering</span>
              </div>
              <div
                className={`store-toggle ${!userData.orderingEnabled ? "on" : ""}`}
              >
                <div className="store-toggle-thumb" />
              </div>
            </button>

            <button
              className="store-settings-row"
              onClick={() => {
                setShowStoreSettings(false);
                navigate("/store/unfulfilled-orders");
              }}
            >
              <div className="store-settings-row-left">
                <FaBookmark className="store-settings-icon" />
                <span className="store-settings-label">Unfulfilled Orders</span>
              </div>
              <span className="store-settings-arrow">›</span>
            </button>

            <button
              className="store-settings-row"
              onClick={() => {
                setShowStoreSettings(false);
                navigate("/store/statistics");
              }}
            >
              <div className="store-settings-row-left">
                <FaTh className="store-settings-icon" />
                <span className="store-settings-label">Statistics</span>
              </div>
              <span className="store-settings-arrow">›</span>
            </button>

            <button
              className="store-settings-row"
              onClick={() => {
                setShowStoreSettings(false);
                setShowManageCategories(true);
              }}
            >
              <div className="store-settings-row-left">
                <FaGlobe className="store-settings-icon" />
                <span className="store-settings-label">Manage Categories</span>
              </div>
              <span className="store-settings-arrow">›</span>
            </button>
          </div>
        </div>
      )}

      {/* Manage Categories overlay */}
      {showManageCategories && isOwn && (
        <div
          className="store-categories-overlay"
          onClick={() => setShowManageCategories(false)}
        >
          <div
            className="store-categories-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="store-categories-header">
              <h3>Manage Categories</h3>
              <button
                className="store-categories-close"
                onClick={() => setShowManageCategories(false)}
              >
                ×
              </button>
            </div>

            <button
              className="store-categories-add-btn"
              onClick={() => {
                setEditingCategory(null);
                setCategoryName("");
                setCategoryDescription("");
                setCategoryColor(STORE_CATEGORY_COLORS[0]);
                setShowCategoryEditor(true);
              }}
            >
              <FaPlus className="store-categories-add-icon" />
              <span>Add Category</span>
            </button>

            <div className="store-categories-list">
              {storeCategories.length === 0 && (
                <div className="store-categories-empty">
                  No categories yet. Create your first one.
                </div>
              )}
              {storeCategories.map((cat) => (
                <div key={cat.id} className="store-category-row">
                  <div className="store-category-main">
                    <span
                      className="store-category-color-dot"
                      style={{ backgroundColor: cat.color || "#6366f1" }}
                    />
                    <div className="store-category-text">
                      <div className="store-category-name">{cat.name}</div>
                      {cat.description && (
                        <div className="store-category-description">
                          {cat.description}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="store-category-actions">
                    <button
                      className="store-category-action-btn"
                      title="Edit"
                      onClick={() => {
                        setEditingCategory(cat);
                        setCategoryName(cat.name || "");
                        setCategoryDescription(cat.description || "");
                        setCategoryColor(cat.color || STORE_CATEGORY_COLORS[0]);
                        setShowCategoryEditor(true);
                      }}
                    >
                      <FaPen />
                    </button>
                    <button
                      className="store-category-action-btn delete"
                      title="Delete"
                      onClick={async () => {
                        if (!currentUser?.id) return;
                        const confirmed = window.confirm(
                          "Delete this category? Products using it will no longer be linked to it."
                        );
                        if (!confirmed) return;
                        try {
                          const { error } = await supabase
                            .from("product_categories")
                            .update({ is_active: false })
                            .eq("id", cat.id)
                            .eq("user_id", currentUser.id);

                          if (error) {
                            console.error("Error deleting category:", error);
                            alert("Failed to delete category.");
                          } else {
                            setStoreCategories((prev) =>
                              prev.filter((c) => c.id !== cat.id)
                            );
                          }
                        } catch (err) {
                          console.error("Error deleting category:", err);
                          alert("Failed to delete category.");
                        }
                      }}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Add / Edit Category overlay */}
      {showCategoryEditor && isOwn && (
        <div
          className="store-category-editor-overlay"
          onClick={() => setShowCategoryEditor(false)}
        >
          <div
            className="store-category-editor-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="store-category-editor-header">
              <h3>{editingCategory ? "Edit Category" : "New Category"}</h3>
              <button
                className="store-category-editor-close"
                onClick={() => setShowCategoryEditor(false)}
              >
                ×
              </button>
            </div>

            <div className="store-category-editor-body">
              <div className="store-category-field">
                <label>Category Name *</label>
                <input
                  type="text"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  placeholder="Enter category name"
                />
              </div>

              <div className="store-category-field">
                <label>Description (Optional)</label>
                <textarea
                  value={categoryDescription}
                  onChange={(e) => setCategoryDescription(e.target.value)}
                  placeholder="Describe your category"
                  rows={3}
                />
              </div>

              <div className="store-category-field">
                <label>Category Color</label>
                <div className="store-category-colors">
                  {STORE_CATEGORY_COLORS.map((color) => (
                    <button
                      key={color}
                      type="button"
                      className={`store-category-color-swatch ${
                        categoryColor === color ? "selected" : ""
                      }`}
                      style={{ backgroundColor: color }}
                      onClick={() => setCategoryColor(color)}
                    >
                      {categoryColor === color && <FaCheck />}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="store-category-editor-actions">
              <button
                className="store-category-btn secondary"
                onClick={() => setShowCategoryEditor(false)}
                disabled={isSavingCategory}
              >
                Cancel
              </button>
              <button
                className="store-category-btn primary"
                disabled={!categoryName.trim() || isSavingCategory}
                onClick={async () => {
                  if (!currentUser?.id || !categoryName.trim()) return;
                  setIsSavingCategory(true);
                  try {
                    if (editingCategory) {
                      const { error } = await supabase
                        .from("product_categories")
                        .update({
                          name: categoryName.trim(),
                          description: categoryDescription.trim() || null,
                          color: categoryColor,
                        })
                        .eq("id", editingCategory.id)
                        .eq("user_id", currentUser.id);

                      if (error) {
                        console.error("Error updating category:", error);
                        alert("Failed to update category.");
                      } else {
                        setStoreCategories((prev) =>
                          prev.map((cat) =>
                            cat.id === editingCategory.id
                              ? {
                                  ...cat,
                                  name: categoryName.trim(),
                                  description:
                                    categoryDescription.trim() || null,
                                  color: categoryColor,
                                }
                              : cat
                          )
                        );
                        setShowCategoryEditor(false);
                      }
                    } else {
                      const payload = {
                        user_id: currentUser.id,
                        name: categoryName.trim(),
                        description: categoryDescription.trim() || null,
                        color: categoryColor,
                        is_active: true,
                        sort_order: storeCategories.length,
                      };

                      const { data, error } = await supabase
                        .from("product_categories")
                        .insert(payload)
                        .select("*")
                        .single();

                      if (error) {
                        console.error("Error creating category:", error);
                        alert("Failed to create category.");
                      } else {
                        setStoreCategories((prev) => [...prev, data]);
                        setShowCategoryEditor(false);
                      }
                    }
                  } catch (err) {
                    console.error("Error saving category:", err);
                    alert("Failed to save category.");
                  } finally {
                    setIsSavingCategory(false);
                  }
                }}
              >
                {isSavingCategory
                  ? "Saving..."
                  : editingCategory
                  ? "Save Changes"
                  : "Create Category"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Subscription Setup Modal Component
function SubscriptionSetupModal({
  subscriptionTab,
  setSubscriptionTab,
  subscriptionAmount,
  setSubscriptionAmount,
  subscriptionDuration,
  setSubscriptionDuration,
  selectedCurrency,
  setSelectedCurrency,
  currencies,
  showCurrencyDropdown,
  setShowCurrencyDropdown,
  flagMap,
  winiToUsdRate,
  calculateWinicoinsFromCurrency,
  isSaving,
  onClose,
  onSave
}) {
  const currencyDropdownRef = useRef(null);
  const [currencySearch, setCurrencySearch] = useState("");

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
        setShowCurrencyDropdown(false);
        setCurrencySearch("");
      }
    };

    if (showCurrencyDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showCurrencyDropdown, setShowCurrencyDropdown]);

  // Filter currencies based on search
  const filteredCurrencies = currencies.filter((currency) => {
    if (!currencySearch.trim()) return true;
    const search = currencySearch.toLowerCase();
    return (
      currency.code.toLowerCase().includes(search) ||
      currency.name.toLowerCase().includes(search)
    );
  });

  // Calculate winicoins preview for currency tab
  const winicoinsPreview = subscriptionTab === "currency" && subscriptionAmount && selectedCurrency
    ? calculateWinicoinsFromCurrency(subscriptionAmount, selectedCurrency.rate)
    : null;

  // Format number with commas
  const formatNumber = (num) => {
    if (!num) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const isSaveDisabled = !subscriptionAmount || !subscriptionDuration || 
    parseInt(subscriptionDuration) < 10 || parseInt(subscriptionDuration) > 60 ||
    (subscriptionTab === "currency" && !selectedCurrency);

  return (
    <div className="subscription-modal-overlay" onClick={onClose}>
      <div className="subscription-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="subscription-modal-header">
          <h2 className="subscription-modal-title">Setup Subscription</h2>
          <button className="subscription-modal-close" onClick={onClose}>×</button>
        </div>

        {/* Tab Selector */}
        <div className="subscription-tab-selector">
          <button
            className={`subscription-tab ${subscriptionTab === "winis" ? "active" : ""}`}
            onClick={() => setSubscriptionTab("winis")}
          >
            Wini's
          </button>
          <button
            className={`subscription-tab ${subscriptionTab === "currency" ? "active" : ""}`}
            onClick={() => setSubscriptionTab("currency")}
          >
            Currency
          </button>
        </div>

        {/* Amount Input */}
        <div className="subscription-input-group">
          <label className="subscription-input-label">
            {subscriptionTab === "winis" ? "Amount (Winicoins)" : "Amount"}
          </label>
          <div className="subscription-amount-input-wrapper">
            <input
              type="text"
              inputMode="decimal"
              className="subscription-amount-input"
              value={formatNumber(subscriptionAmount)}
              onChange={(e) => setSubscriptionAmount(e.target.value.replace(/[^\d.]/g, ""))}
              placeholder="0"
            />
            {subscriptionTab === "winis" ? (
              <span className="subscription-amount-unit">Winicoins</span>
            ) : (
              <div className="subscription-currency-selector" ref={currencyDropdownRef}>
                <button
                  className="subscription-currency-button"
                  onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
                >
                  {selectedCurrency ? (
                    <>
                      <img
                        src={selectedCurrency.flag}
                        alt={selectedCurrency.code}
                        className="subscription-currency-flag"
                      />
                      <span className="subscription-currency-code">{selectedCurrency.code}</span>
                    </>
                  ) : (
                    <span className="subscription-currency-placeholder">Select currency</span>
                  )}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="#666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                {showCurrencyDropdown && (
                  <div className="subscription-currency-dropdown">
                    <div className="subscription-currency-search-wrapper">
                      <input
                        type="text"
                        className="subscription-currency-search"
                        placeholder="Search currency..."
                        value={currencySearch}
                        onChange={(e) => setCurrencySearch(e.target.value)}
                        autoFocus
                      />
                    </div>
                    <div className="subscription-currency-list">
                      {filteredCurrencies.length === 0 ? (
                        <div className="subscription-currency-empty">No currencies found</div>
                      ) : (
                        filteredCurrencies.map((currency) => (
                        <button
                          key={currency.code}
                          className={`subscription-currency-option ${selectedCurrency?.code === currency.code ? "selected" : ""}`}
                          onClick={() => {
                            setSelectedCurrency(currency);
                            setShowCurrencyDropdown(false);
                          }}
                        >
                          <img
                            src={currency.flag}
                            alt={currency.code}
                            className="subscription-currency-flag"
                          />
                          <div className="subscription-currency-option-text">
                            <span className="subscription-currency-option-code">{currency.code}</span>
                            <span className="subscription-currency-option-name">{currency.name}</span>
                          </div>
                        </button>
                      ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {subscriptionTab === "currency" && winicoinsPreview && (
            <div className="subscription-preview">
              ≈ {formatNumber(winicoinsPreview.toFixed(2))} Winicoins
            </div>
          )}
        </div>

        {/* Duration Input */}
        <div className="subscription-input-group">
          <label className="subscription-input-label">Duration (10-60 days)</label>
          <input
        type="text"
        inputMode="numeric"
        className="subscription-duration-input"
        value={subscriptionDuration}
        onChange={(e) => {
          const value = e.target.value.replace(/[^\d]/g, "");
          setSubscriptionDuration(value);
        }}
        placeholder="Enter duration (10-60 days)"
      />
        </div>

        {/* Action Buttons */}
        <div className="subscription-modal-actions">
          <button
            className="subscription-modal-button subscription-modal-button-cancel"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            className="subscription-modal-button subscription-modal-button-save"
            onClick={onSave}
            disabled={isSaveDisabled || isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

// Locked subscription card for visitors
function LockedSubscriptionCard({ user, winiToUsdRate }) {
  const costWini = Number(user.subscriptionCost || 0);
  const costUsd = winiToUsdRate ? costWini * winiToUsdRate : null;

  return (
    <div className="locked-subscription-card">
      <div className="locked-subscription-header">
        <div className="locked-avatar-wrapper">
          <img
            src={user.profileImage}
            alt={user.username}
            className="locked-avatar-image"
          />
          <div className="locked-avatar-glow" />
        </div>
        <h2 className="locked-subscription-title">
          Subscribe to {user.username}
        </h2>
        <p className="locked-subscription-subtitle">
          Get access to exclusive content and premium features.
        </p>
      </div>

      <div className="locked-subscription-plan">
        <div className="locked-plan-left">
          <div className="locked-plan-check">
            <FaCheck className="locked-plan-check-icon" />
          </div>
          <span className="locked-plan-duration">
            {user.subscriptionDuration || 30} days
          </span>
        </div>
        <div className="locked-plan-right">
          <div className="locked-plan-price-main">
            {costUsd !== null ? `$${costUsd.toFixed(2)}` : "--"}
          </div>
          <div className="locked-plan-price-sub">
            {costWini.toFixed(2)} Wini
          </div>
        </div>
      </div>

      <div className="locked-subscription-features">
        <div className="locked-feature-item">
          <div className="locked-feature-icon lock">
            <FaEyeSlash className="locked-feature-icon-inner" />
          </div>
          <div>
            <div className="locked-feature-title">Private Content Access</div>
            <div className="locked-feature-text">
              Unlock exclusive posts and media content.
            </div>
          </div>
        </div>
        <div className="locked-feature-item">
          <div className="locked-feature-icon priority">
            <FaExclamation className="locked-feature-icon-inner" />
          </div>
          <div>
            <div className="locked-feature-title">Priority Support</div>
            <div className="locked-feature-text">
              Get faster responses and direct communication.
            </div>
          </div>
        </div>
        <div className="locked-feature-item">
          <div className="locked-feature-icon star">
            <FaStar className="locked-feature-icon-inner" />
          </div>
          <div>
            <div className="locked-feature-title">Exclusive Benefits</div>
            <div className="locked-feature-text">
              Access special features and early content.
            </div>
          </div>
        </div>
      </div>

      <button
        className="locked-subscription-button"
        onClick={() => {
          // Actual subscription flow handled in parent via confirmation dialog
          if (typeof window !== "undefined") {
            const event = new CustomEvent("profile-subscribe-click");
            window.dispatchEvent(event);
          }
        }}
      >
        Subscribe now
      </button>
    </div>
  );
}

// Store product card for store tab
function StoreProductCard({ product, winiToUsdRate }) {
  const [isLiked, setIsLiked] = useState(false);
  const navigate = useNavigate();

  const priceCoins = Number(product.price_in_coins || 0);
  const priceUsd = winiToUsdRate ? priceCoins * winiToUsdRate : null;

  const firstImage =
    (Array.isArray(product.images) && product.images[0]) || product.thumbnail_url || null;

  const imageUrl = resolveProductImageUrl(firstImage, product.user_id);

  const handleToggleLike = (e) => {
    e.stopPropagation();
    setIsLiked((prev) => !prev);
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();

    try {
      // Map Supabase product to cart item shape
      const cartProduct = {
        id: product.id,
        Title: product.name,
        Images: [imageUrl],
        Price: priceUsd ?? priceCoins,
        VendorId: product.user_id,
      };

      addToCart(cartProduct);
      alert("Product added to cart.");
    } catch (err) {
      console.error("Failed to add product to cart:", err);
    }
  };

  const handleCardClick = () => {
    navigate(`/product-details/${product.user_id}/${product.id}`);
  };

  return (
    <div className="store-product-card" onClick={handleCardClick} style={{ cursor: "pointer" }}>
      <div className="store-product-image-wrapper">
        <img
          src={imageUrl}
          alt={product.name || "Product"}
          onError={(e) => {
            e.currentTarget.src = "/default-product.png";
          }}
        />
      </div>
      <div className="store-product-info">
        <div className="store-product-name">{product.name}</div>
        <div className="store-product-price-row">
          <div className="store-product-price-text">
            {/* <span className="store-product-price-coins">
              {priceCoins.toFixed(2)} Wini
            </span> */}
            {priceUsd !== null && (
              <span className="store-product-price-fiat">
                {" "}
                 ${priceUsd.toFixed(2)}
              </span>
            )}
          </div>
          <div className="store-product-actions">
            <button
              className={`store-product-like-btn ${isLiked ? "liked" : ""}`}
              onClick={handleToggleLike}
              title={isLiked ? "Unlike" : "Like"}
            >
              <FaHeart />
            </button>
            <button
              className="store-product-cart-btn"
              onClick={handleAddToCart}
              title="Add to cart"
            >
              <FaShoppingCart />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Enhanced Audio Player Component
function AudioPlayer({ src, post }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const handlePlayPause = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleBackward = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (audioRef.current) {
      audioRef.current.currentTime = Math.max(0, audioRef.current.currentTime - 10);
    }
  };

  const handleForward = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (audioRef.current) {
      audioRef.current.currentTime = audioRef.current.currentTime + 10;
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  // Create gradient background from Firebase bgColors
  const bgColor1 = post.bgColor1 || '#1b1b19';
  const bgColor2 = post.bgColor2 || '#2d2d2b';
  const gradientBg = `linear-gradient(135deg, #${bgColor1.replace('#', '')}, #${bgColor2.replace('#', '')})`;

  const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

  return (
    <div className="enhanced-audio-player-container">
      <div 
        className="enhanced-audio-player-background"
        style={{ background: gradientBg }}
      >
        {/* Circular Cover Image */}
        {post.compressedCoverImage && (
          <div className="audio-cover-circle">
            <img 
              src={post.compressedCoverImage} 
              alt="Audio Cover" 
              className="audio-cover-circular"
            />
          </div>
        )}
        
        {/* Audio Controls */}
        <div className="audio-controls">
          <button className="audio-control-btn backward" onClick={handleBackward}>
            <FaBackward />
          </button>
          <button className="audio-control-btn play-pause" onClick={handlePlayPause}>
            {isPlaying ? <FaPause /> : <FaPlay />}
          </button>
          <button className="audio-control-btn forward" onClick={handleForward}>
            <FaForward />
          </button>
        </div>

        {/* Progress Bar */}
        <div className="audio-progress-container">
          <div className="audio-progress-bar">
            <div 
              className="audio-progress-fill" 
              style={{ width: `${progress}%` }}
            />
            <div 
              className="audio-progress-handle" 
              style={{ left: `${progress}%` }}
            />
          </div>
          <div className="audio-time-display">
            {formatTime(currentTime)} / {formatTime(duration)}
          </div>
        </div>
      </div>
      
      <audio 
        ref={audioRef}
        src={src} 
        className="hidden-audio-controls"
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
      />
    </div>
  );
}

// Link thumbnail helper (same as Feed.jsx)
function getLinkThumbnail(url) {
  if (!url) return "/default-link-thumb.png";

  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");

    // YouTube
    if (host === "youtu.be") {
      const videoId = u.pathname.slice(1);
      return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
    } else if (host.includes("youtube.com")) {
      const videoId = u.searchParams.get("v");
      if (videoId) {
        return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
      }
    }

    // Instagram
    const igReel = url.match(/instagram\.com\/(?:reel|p)\/([^\/?]+)/);
    if (igReel) {
      return "/default-instagram-thumb.jpeg";
    }

    // TikTok
    const ttPatterns = [
      /tiktok\.com\/@[^\/]+\/video\/(\d+)/,
      /vm\.tiktok\.com\/[^\/]+/,
      /vt\.tiktok\.com\/[^\/]+/,
      /www\.tiktok\.com\/t\/[^\/]+/,
      /tiktok\.com\/t\/[^\/]+/
    ];
    const isTikTok = ttPatterns.some(pattern => pattern.test(url));
    if (isTikTok) {
      return "/default-tiktok-thumb.jpeg";
    }

    return "/default-link-thumb.png";
  } catch (err) {
    return "/default-link-thumb.png";
  }
}

// Renders only the first media item (image, video, audio, or text)
function SlimPost({ post, userId, tab, isOwn }) {
  const raw =
    Array.isArray(post.media) && post.media.length
      ? post.media
      : Array.isArray(post.compressedMedia)
      ? post.compressedMedia
      : [];
  const entry = raw[0]
    ? typeof raw[0] === "string"
      ? JSON.parse(raw[0])
      : raw[0]
    : null;

  const isLocked = post.isLocked === true;
  const hasUrl = post.caption && /(https?:\/\/[^\s]+|www\.[^\s]+)/i.test(post.caption);
  
  // Owner should see their own locked posts without the locked overlay
  // but with a small lock badge to indicate it's a locked post
  const showLockedOverlay = isLocked && !isOwn;
  const showOwnerLockBadge = isLocked && isOwn;

  // If has media, show the media (original behavior)
  if (entry) {
    return (
      <Link
        to={`/profile_posts/${userId}?tab=${tab}&scrollTo=${post.id}`}
        className={`slim-post ${isLocked && !isOwn ? 'locked' : ''}`}
      >
        {/* Hide media when locked for non-owners */}
        {(!isLocked || isOwn) && (
          <>
            {entry.type === "image" && <img src={entry.url} alt="" className="slim-image" />}
            {entry.type === "video" && <video controls src={entry.url} className="slim-video" />}
            {entry.type === "audio" && <AudioPlayer src={entry.url} post={post} />}
            
            {/* Render audio inside the card at the bottom */}
            {post.audioUrl && entry.type !== "audio" && (
              <div className="slim-audio-wrapper">
                <audio controls src={post.audioUrl} className="slim-audio-player" />
              </div>
            )}
          </>
        )}

        {post.isPrivate && (
          <div className="slim-private-badge">
            Private
          </div>
        )}
        
        {/* Small white lock badge for owner's locked posts */}
        {showOwnerLockBadge && (
          <div className="slim-owner-lock-badge">
            <FaLock className="slim-owner-lock-icon" />
          </div>
        )}
        
        {/* Full locked overlay for non-owners */}
        {showLockedOverlay && (
          <div className="profile-locked-overlay">
            <div className="lock-icon-container">
              <FaLock className="lock-icon" />
            </div>
          </div>
        )}
      </Link>
    );
  }

  // If no media but has text/link, create a text post preview
  // if (post.caption) {
  //   const urlMatch = post.caption.match(/(https?:\/\/[^\s]+|www\.[^\s]+)/i);
  //   const linkUrl = urlMatch ? urlMatch[0] : null;
    
  //   // For link posts, open in new tab instead of going to ProfilePosts
  //   if (hasUrl && linkUrl) {
  //     return (
  //       <div
  //         className={`slim-post ${isLocked ? 'locked' : ''} text-post link-post`}
  //         onClick={() => window.open(linkUrl, '_blank')}
  //         style={{ cursor: 'pointer' }}
  //       >
  //         <div className="text-post-content">
  //           <div className="link-thumbnail-container">
  //             <img 
  //               src={getLinkThumbnail(linkUrl)} 
  //               alt="Link thumbnail" 
  //               className="link-thumbnail-image"
  //               onError={(e) => {
  //                 e.target.src = "/default-link-thumb.png";
  //               }}
  //             />
  //           </div>
  //         </div>
  //         {isLocked && (
  //           <div className="profile-locked-overlay">
  //             <div className="lock-icon-container">
  //               <FaLock className="lock-icon" />
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     );
  //   }
    
  //   // For text-only posts, go to ProfilePosts
  //   return (
  //     <Link
  //       to={`/profile_posts/${userId}?tab=${tab}&scrollTo=${post.id}`}
  //       className={`slim-post ${isLocked ? 'locked' : ''} text-post`}
  //     >
  //       <div className="text-post-content">
  //         <div className="text-only-preview">
  //           <FaFont className="text-icon" />
  //           <p className="post-text">{post.caption}</p>
  //         </div>
  //       </div>
  //       {isLocked && (
  //         <div className="profile-locked-overlay">
  //           <div className="lock-icon-container">
  //             <FaLock className="lock-icon" />
  //           </div>
  //         </div>
  //       )}
  //     </Link>
  //   );
  // }

  return null;
}